// 如果在模块化构建系统中，请确保在开头调用了
import Vue from 'vue'
import Vuex from 'vuex'

// 用户信息服务
import userInfo from './modules/user'

// 药商、药房、药品管理相关
import pharmacyManagement from '@/pages/pharmacyManage/store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    userInfo,
    ...pharmacyManagement
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js